export default __webpack_public_path__ + "static/media/10.de5303ee.png";